import { render, staticRenderFns } from "./pkgDetail.vue?vue&type=template&id=480317ac&scoped=true"
import script from "./pkgDetail.vue?vue&type=script&lang=js"
export * from "./pkgDetail.vue?vue&type=script&lang=js"
import style0 from "./pkgDetail.vue?vue&type=style&index=0&id=480317ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480317ac",
  null
  
)

export default component.exports